module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "customer"
  }, [(_vm.item.attr === 'templateId') ? [_c('el-select', {
    attrs: {
      "disabled": _vm.item.nonEditable === 1,
      "placeholder": "请选择"
    },
    on: {
      "change": _vm.handleTemp
    },
    model: {
      value: (_vm.form[_vm.item.attr]),
      callback: function($$v) {
        _vm.$set(_vm.form, _vm.item.attr, $$v)
      },
      expression: "form[item.attr]"
    }
  }, _vm._l((_vm.item.valueArrMap), function(arr) {
    return _c('el-option', {
      key: arr.key,
      attrs: {
        "label": arr.value,
        "value": arr.key
      }
    })
  }))] : (_vm.item.attr === 'customerName') ? [_c('associated-field', {
    ref: "associatedField",
    attrs: {
      "module": "customerApi",
      "item": _vm.item,
      "form": _vm.form
    },
    on: {
      "addNew": _vm.addNew,
      "emitObj": _vm.changeCustomer
    }
  })] : (_vm.item.attr === 'opportunityId') ? [(_vm.form.customerName.id) ? _c('associated-field', {
    ref: "associatedField",
    attrs: {
      "module": "opportunityApi",
      "item": _vm.item,
      "form": _vm.form,
      "customerId": _vm.form.customerName.id
    },
    on: {
      "addNew": _vm.addNew
    }
  }) : _c('span', [_vm._v("无")])] : (_vm.item.attr === 'partnerName') ? [_c('associated-field', {
    ref: "associatedField",
    attrs: {
      "module": "customerApi",
      "item": _vm.item,
      "form": _vm.form
    },
    on: {
      "addNew": _vm.addNew
    }
  })] : (_vm.item.attr === 'contactName') ? [(_vm.form.customerName.id) ? _c('associated-field', {
    ref: "associatedField",
    attrs: {
      "module": "contactApi",
      "multiselect": false,
      "item": _vm.item,
      "form": _vm.form,
      "customerId": _vm.form.customerName.id
    },
    on: {
      "addNew": _vm.addNew
    }
  }) : _c('span', [_vm._v("无")])] : (_vm.item.attr === 'signPerson') ? [_c('v-manager', {
    attrs: {
      "item": _vm.item,
      "form": _vm.form
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "prompt"
  }, [_vm._v("目标PK、绩效PK等数据统计时，合同金额绩效归属于“签订人”。")])] : (_vm.item.attr === 'products') ? [_c('div', {
    staticClass: "products type2"
  }, [_c('input', {
    staticClass: "v-input",
    attrs: {
      "type": "text",
      "placeholder": "暂无关联产品",
      "readonly": ""
    },
    domProps: {
      "value": _vm._f("productLen")(_vm.Products.productList)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "v-area"
  }, [(_vm.Products.productList && _vm.Products.productList.length) ? [_vm._v("产品合计(元)：" + _vm._s(_vm._f("totalPrice")(_vm.Products.productList)) + "；"), _vm._l((_vm.Products.surchargeList), function(item) {
    return _c('span', {
      class: {
        'discount': item.surchargeType === 2
      }
    }, [_vm._v(_vm._s(item.surchargeName) + "(元)：" + _vm._s(_vm._f("fiexd")(item.amount)) + " ; ")])
  })] : [_vm._v("产品合计(元)：0元；其它费用：0元")]], 2), _vm._v(" "), _c('span', {
    staticClass: "add-btn",
    on: {
      "click": _vm.emitParent
    }
  }, [_vm._v("选择")])])] : (_vm.item.attr === 'payment') ? [_c('payment-box', {
    ref: "paymentBox",
    attrs: {
      "moduleName": 'contractApi',
      "contractNo": _vm.form['contractNo'],
      "contractId": this.detailId || 0,
      "totalMoney": _vm.form['totalMoney']
    }
  })] : (_vm.item.attr === 'name') ? _c('div', {
    staticClass: "customerName"
  }, [_c('el-input', {
    on: {
      "focus": function($event) {
        _vm.repeatListShow = true
      },
      "blur": function($event) {
        _vm.repeatListShow = false
      }
    },
    model: {
      value: (_vm.form[_vm.item.attr]),
      callback: function($$v) {
        _vm.$set(_vm.form, _vm.item.attr, $$v)
      },
      expression: "form[item.attr]"
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isNameCheck && _vm.repeatListShow),
      expression: "isNameCheck && repeatListShow"
    }],
    staticClass: "repeat-list"
  }, [_c('h4', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.listData.length),
      expression: "listData.length"
    }],
    staticClass: "title"
  }, [_vm._v("已存在以下合同，请勿重复添加")]), _vm._v(" "), _c('ul', _vm._l((_vm.listData), function(item) {
    return _c('li', {
      staticClass: "item"
    }, [_vm._v(_vm._s(item.name))])
  }))])], 1) : [_vm._v(_vm._s(_vm.item.attr))]], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-82875f6e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/fieldtype/contract/index.vue
// module id = 1312
// module chunks = 82